import React from 'react';
import PropTypes from 'prop-types';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider_custom';
import CarouselSlider2 from 'components/atoms/TemplateCarouselSlider_nobtn';
import { Slide } from 'pure-react-carousel';
import ReactHtmlParser from 'react-html-parser';

const ListBtnElement = ({ onClickEvt, data, styleDef }) => {
  return (
    <div
      className="_list_btn_card_button"
      style={styleDef}
      onClick={e => (data.label === '<br/>' ? '' : onClickEvt(data.value, data.action, data.label))}
      role="button"
      tabIndex={0}
      onKeyPress={e => {
        if (e.key === 'Enter' && data.label !== '<br/>') {
          onClickEvt(data.value, data.action, data.label);
        }
      }}
    >
      {ReactHtmlParser(data.label)}
    </div>
  );
};

const ListButtonCard = ({ boxStyle, slideBoxSet, item, viewType, onClickEvt }) => {
  const { items, type } = item;

  const slideLength = items.length;
  let slideBoxSetStyle;

  if (slideLength < 2) {
    slideBoxSetStyle = {
      width: `${slideBoxSet.width}px`,
      height: slideBoxSet.height,
      margin: `0 ${slideBoxSet.margin}px`,
      outline: 'none',
    };
  } else {
    slideBoxSetStyle = {
      width: '160px',
      height: slideBoxSet.height,
      margin: `0 ${slideBoxSet.margin}px`,
      outline: 'none',
    };
  }

  const constentSet = () => {
    let subTypeMaxLen = 0;

    // 8개이면 생활불편 신고로 판단
    if (items.length === 8) {
      for (const mainType of items) {
        for (const subType of mainType.button) {
          const len = subType.label.split(',').length;
          subTypeMaxLen = len > subTypeMaxLen ? len : subTypeMaxLen;
        }
      }
    }

    return (
      <>
        {items.map((tempItem, idx) => {
          return (
            <Slide key={`slide_${idx}`} index={idx} className="_list_btn_card" style={slideBoxSetStyle}>
              <div className="_list_btn_card_title">
                <div className="_title_img" style={boxStyle}>{ReactHtmlParser(tempItem.text.desc)}</div>
              </div>
              {tempItem.button.map((data, number) => {
                const splitLabel = data.label.split(',');
                const splitValue = data.value.split(',');

                /*
                if (splitLabel.length < subTypeMaxLen) {
                  const emptyDataLen = subTypeMaxLen - splitLabel.length;
                  for (let i = 0; i < emptyDataLen; i += 1) {
                    splitLabel.push('<br/>');
                    splitValue.push('<br/>');
                  }
                }
                */

                return splitLabel.map((lbl, order) => {
                  const splitData = {};
                  splitData.action = data.action;
                  splitData.label = lbl;
                  splitData.value = splitValue[order];
                  return splitValue[order] && lbl ? (
                    <ListBtnElement key={'list_btn_ele_' + number + '_' + order} styleDef={boxStyle} onClickEvt={onClickEvt} data={splitData} />
                  ) : (
                    ''
                  );
                });
              })}
            </Slide>
          );
        })}
      </>
    );
  };
  return (
    <>
      {slideLength >= 3 ? (
        <div className="_carousel_button_div">
          <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
        </div>
      ) : (
        <div className="_carousel_button_div">
          <CarouselSlider2 slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
        </div>
      )}
    </>
  );
};
ListButtonCard.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet:  PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ListButtonCard.defaultProps = {
  boxStyle: {},
  slideBoxSet: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

ListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
};
ListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
};

export default ListButtonCard;
